import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";

import { t } from "../../services";

import SVG from "../SVG/icons";
import FlexContainers from "../Containers/FlexContainers";
import { FilterModal } from "./components/FilterModal";

import { FilterInputContainer, HiddenOptionsCircle } from "./styled";

const FilterInput = ({
  options,
  isSearchable,
  selectedOptions,
  onSelectedOptionsChanged,
  allOptionsText,
  isActive,
  title,
  description,
  searchPlaceholder,
  columnName,
  CellComponent,
  Component,
  selectedOptionsState,
  maxVisibleValues = 2,
  onModalActiveChange
}) => {
  const [filterModalActive, setFilterModalActive] = useState(false);

  const onFiltersSelected = (selectedIds) => {
    const filteredOptions = options.filter((x) => selectedIds.includes(x.id));

    onSelectedOptionsChanged(
      filteredOptions.length == options.length ? [] : filteredOptions.map((x) => x.id)
    );
  };

  const [displayText, hiddenOptions] = useMemo(() => {
    if (!selectedOptions || selectedOptions.length == 0) {
      return [t(allOptionsText), 0];
    } else {
      const values = options
        .filter((option) =>
          selectedOptions?.some((selectedOption) => selectedOption.id === option.id)
        )
        .map((x) => t(x.value));

      let result = values.slice(0, maxVisibleValues).join(", ");

      return [result, values.length > maxVisibleValues ? values.length - maxVisibleValues : 0];
    }
  }, [options, selectedOptions, allOptionsText, maxVisibleValues]);

  useEffect(() => {
    if (onModalActiveChange) {
      onModalActiveChange(filterModalActive);
    }
  }, [filterModalActive]);

  return (
    <>
      <FilterInputContainer
        active={isActive}
        Container={FlexContainers.FlexRowStart}
        onClick={() => setFilterModalActive(true)}>
        <span>{displayText}</span>
        {hiddenOptions > 0 && <HiddenOptionsCircle>+{hiddenOptions}</HiddenOptionsCircle>}
        <SVG.DownArrowIcon />
      </FilterInputContainer>
      <FilterModal
        active={filterModalActive}
        setActive={setFilterModalActive}
        onSubmit={onFiltersSelected}
        options={options}
        selectedOptions={selectedOptions}
        title={title}
        description={description}
        searchPlaceholder={searchPlaceholder}
        columnName={columnName}
        isSearchable={isSearchable}
        CellComponent={CellComponent}
        Component={Component}
        selectedOptionsState={selectedOptionsState}
      />
    </>
  );
};

FilterInput.propTypes = {
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  onSelectedOptionsChanged: PropTypes.func.isRequired,
  allOptionsText: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired,
  maxVisibleValues: PropTypes.number,
  isSearchable: PropTypes.bool,
  CellComponent: PropTypes.object,
  Component: PropTypes.node,
  selectedOptionsState: PropTypes.array,
  onModalActiveChange: PropTypes.func
};

export default FilterInput;
